module.exports = __webpack_public_path__ + "static/media/chatbotAvatar.a3a27c44.svg";